import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TreeModule } from '@circlon/angular-tree-component';
import { TranslateModule } from '@ngx-translate/core';
import { TreeDropdownComponent } from './tree-dropdown.component';
import { ClickOutsideModule } from 'ng-click-outside';

@NgModule({
  declarations: [TreeDropdownComponent],
  imports: [
    CommonModule,
    TranslateModule,
    TreeModule,
    ClickOutsideModule,
  ],
  exports: [TreeDropdownComponent],
})
export class TreeDropdownModule {}
